<script lang="ts">
    import { mdiCloseCircleOutline } from "@mdi/js"
    import { overlays } from "../store"
    import Icon from "./widgets/Icon.svelte"
    import { changeStateOfSite } from "./header/Desktop.svelte"
    $: changeStateOfSite(!!$overlays.length)
    $: console.log($overlays)
</script>

<section
    class:visible="{$overlays.length}"
    class="sidebarOverlay"
    id="overlay"
>
    <section class="dark-side"></section>
    <ul class="content-side">
        {#each $overlays as overlay, i}
            <li
                class="content-block"
                class:active="{overlay.active}"
                class:dark="{(i + 1) % 2 == 0}"
            >
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <header
                    class:noBg="{i === $overlays.length - 1}"
                    on:click="{() => {
                        $overlays = $overlays.map((o, index) => {
                            o.active = index === i
                            return o
                        })
                    }}"
                >
                    <div class="crinkle">
                        <img
                            src="/media/ModalCrinkle{(i + 1) % 2 == 0 ? 'Dark' : ''}.svg"
                            alt="crinkle"
                        />
                    </div>
                    {#if typeof overlay.title === "string"}
                        <h3>
                            {overlay.title}
                        </h3>
                    {:else}
                        <svelte:component this="{overlay.title}" />
                    {/if}
                    <div class="close">
                        <button
                            on:click="{() => {
                                const removedElements = $overlays.splice(i, $overlays.length - i)
                                const hasActive = removedElements.some((element) => element.active === true)
                                if (hasActive && $overlays.length > 0) {
                                    $overlays[$overlays.length - 1].active = true
                                }
                            }}"
                        >
                            <Icon
                                path="{mdiCloseCircleOutline}"
                                size="32px"
                            />
                        </button>
                    </div>
                </header>
                <div
                    class="content-listing"
                    class:active="{overlay.active}"
                >
                    <svelte:component
                        this="{overlay.content}"
                        darkBg="{(i + 1) % 2 == 0}"
                        {...overlay.properties}
                    />
                </div>
            </li>
        {/each}
    </ul>
</section>

<style lang="less">
    @import "../assets/css/variables.less";
    :global .sidebarOverlay {
        position: fixed;

        left: initial;
        right: 0;
        width: 100vw;
        height: 100vh;
        top: 0px;
        overflow: hidden;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: flex-end;
        bottom: -200vh;
        top: 200vh;
        &.visible {
            bottom: 0px;
            top: 0px;
        }
        @media @desktop {
            top: 0px;
            bottom: 0px;
            right: -100vw;
            &.visible {
                right: 0px;
            }
        }
        .dark-side {
            flex-grow: 1;
            height: 100%;
        }
        .content-side {
            width: 100vw;
            display: flex;
            align-items: flex-end;
            flex-direction: column-reverse;
            @media @desktop {
                flex-direction: row-reverse;
            }
            height: fit-content;
            .content-block {
                max-height: 70vh;
                @media @desktop {
                    max-height: 100vh;
                }
                height: fit-content;
                width: 100%;

                header {
                    width: 100%;
                    display: flex;
                    height: 88px;
                    background-color: var(--bg-100);
                    &.noBg {
                        background-color: transparent;
                    }
                    .crinkle {
                        margin-right: -1px;
                        height: 100%;
                        width: auto;
                    }
                    h3 {
                        background-color: var(--neutral-white);
                        flex-grow: 1;
                        color: var(--text-invers-100);
                        display: flex;
                        align-items: flex-end;
                    }
                    .close {
                        background-color: var(--neutral-white);
                        padding-right: 27px;
                        color: var(--text-invers-100);
                        display: flex;
                        align-items: flex-end;
                        button {
                            color: var(--text-invers-100);
                        }
                    }
                }
                @media @desktop {
                    width: 50vw;
                    border-left: 1px solid var(--bg-invers-100);
                    overflow-y: auto;
                }
                @media @large_desktop {
                    width: max(30vw, 628px);
                }
                .content-listing {
                    width: 100%;
                    padding: 48px 27px 0px 86px;
                    background-color: var(--neutral-white);
                    display: flex;
                    flex-direction: column;
                    height: 0px;
                    max-height: 0px;
                    overflow-y: hidden;
                    &.active {
                        display: flex;
                        height: calc(100vh - 88px);
                        max-height: calc(100vh - 88px);
                    }
                }
                @media @desktop {
                    .content-listing {
                        height: calc(100vh - 88px);
                        max-height: 100vh;
                    }
                }

                &.dark {
                    header {
                        background-color: var(--neutral-white);
                        &.noBg {
                            background-color: transparent;
                        }
                        h3 {
                            background-color: var(--bg-100);
                            color: var(--text-100);
                        }
                        .close {
                            background-color: var(--bg-100);
                            button {
                                color: var(--text-100) !important;
                                svg {
                                    fill: var(--text-100);
                                }
                            }
                        }
                    }
                    .content-listing {
                        background-color: var(--bg-100);
                        color: var(--text-100);
                    }
                }
            }
        }
    }
</style>
